import * as React from 'react'
import { BigHeaderConnected } from './BigHeaderConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const BigHeaderExamples = () => {
  return (
    <div className="BigHeaderExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <BigHeaderConnected />
      </Provider>
    </div>
  )
}
